<template>
  <b-modal
    id="edit-info-client"
    size="lg"
    :title="$t('clients.edit_client_requisites')"
    :ok-title="$t('generals.update')"
    ok-variant="success"
    :cancel-title="$t('generals.cancel')"
    cancel-variant="danger"
    @ok="onSubmit"
  >
    <validation-observer
      ref="validationAdditionalInfoClient"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <b-form-group
            :label="$t('clients.legal_address')"
            label-for="name"
          >
            <validation-provider
              #default="{ errors }"
              name="address"
              rules="required"
            >
              <b-form-input
                id="address"
                v-model="client.address"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            :label="$t('clients.inn')"
            label-for="name"
          >
            <validation-provider
              #default="{ errors }"
              name="INN"
              rules="required|length:9"
            >
              <b-form-input
                id="name"
                v-model="client.inn"
                type="number"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('clients.okved')"
            label-for="name"
          >
            <validation-provider
              #default="{ errors }"
              name="OKED"
              rules="required|length:5"
            >
              <b-form-input
                id="name"
                v-model="client.oked"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('clients.nds_code')"
            label-for="name"
          >
            <validation-provider
              #default="{ errors }"
              name="username"
              rules="required"
            >
              <b-form-input
                id="name"
                v-model="client.code_nds"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BFormInput, BFormGroup,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  data() {
    return {
      required,
      client: {
        address: '',
        code_nds: '',
        inn: '',
        oked: '',
      },
    }
  },
  methods: {
    ...mapActions('clients', ['UDATE_ONE_CLIENT', 'FETCH_ONE_CLIENT']),
    onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()

      this.$refs.validationAdditionalInfoClient.validate().then(async success => {
        if (success) {
          await this.UDATE_ONE_CLIENT({
            id: this.$route.params.id,
            data: this.client,
          })

          this.$nextTick(() => {
            this.$bvModal.hide('edit-info-client')
          })

          this.FETCH_ONE_CLIENT(this.$route.params.id)
        }
      })
    },
  },
  computed: {
    ...mapGetters('clients', ['getOneClient']),
  },
  watch: {
    getOneClient(newValue) {
      this.client.inn = newValue.inn
      this.client.address = newValue.address
      this.client.code_nds = newValue.code_nds
      this.client.oked = newValue.oked
    },
  },
  components: {
    BModal, BRow, BCol, BFormInput, BFormGroup, ValidationProvider, ValidationObserver,
  },
}
</script>

<style>

</style>
